import { render, staticRenderFns } from "./CashierCard.vue?vue&type=template&id=2d1007b5&scoped=true&"
import script from "./CashierCard.vue?vue&type=script&lang=js&"
export * from "./CashierCard.vue?vue&type=script&lang=js&"
import style0 from "./CashierCard.vue?vue&type=style&index=0&id=2d1007b5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1007b5",
  null
  
)

export default component.exports